module.exports = __webpack_public_path__ + "img/logo_10.7ff6380a.png";